export enum TokenStatus {
  Inactive = 0,
  Active = 1,
  Expired = 2,
}
